import React, { useState, useRef, useEffect } from "react"
import { SubmenuLink } from "./submenu-link"
import { CaretIcon } from "components/page-components/Icons/small"

export const BfzTopics = ({ links }) => {
  const [scroll_amount, set_scroll_amount] = useState(0)
  const linkbar_ref = useRef(null)
  const scroll_interval = 350

  const scroll_right = (e) => {
    e.preventDefault()
    set_scroll_amount(
      Math.min(scroll_amount + scroll_interval, linkbar_ref.current.clientWidth)
    )
  }

  const scroll_left = (e) => {
    e.preventDefault()

    set_scroll_amount(Math.max(scroll_amount - scroll_interval, 0))
  }

  useEffect(() => {
    linkbar_ref.current.scrollTo({
      top: 0,
      left: scroll_amount,
      behavior: "smooth",
    })
  }, [scroll_amount])

  return (
    <div
      className="no-scrollbar is-flex"
      style={{
        overflowX: "auto",
        position: "relative",
      }}
      ref={linkbar_ref}
    >
      <a
        style={{
          fontSize: 18,
          height: "100%",
          position: "sticky",
          left: 0,
          zIndex: 19,
          textAlign: "center",
          lineHeight: "80px",
          display: !scroll_amount,
        }}
        onClick={scroll_left}
        href=" #"
        className="has-text-white has-background-umweltbau pr-3 pl-4"
      >
        <CaretIcon {...{ color: "#FFFFFF", rotation: "left", size: 0.9 }} />
      </a>

      {links.map(({ label, link }, index) => (
        <SubmenuLink {...{ label, link, key: "submenu-link" + index }} />
      ))}
      <a
        style={{
          fontSize: 18,
          height: "100%",
          position: "sticky",
          right: 0,
          zIndex: 19,
          textAlign: "center",
          lineHeight: "80px",
          display: !!scroll_amount,
        }}
        onClick={scroll_right}
        href=" #"
        className="has-text-white has-background-umweltbau pr-3 pl-4"
      >
        <CaretIcon {...{ color: "#FFFFFF", rotation: "right", size: 0.9 }} />
      </a>
    </div>
  )
}
